import React from 'react';
import PropTypes from 'prop-types';
import Item from './Item.jsx';
import moment from 'moment';

const titles = {
  registered: 'Registered users',
  logged: 'Logged',
  user_type: 'User Type',
  hospital: 'Hospital',
  county: 'County',
}

  // registered_users,
  // total_users
function Carts({
  statistics: {
    registered_users,
    logged_in_users,
    user_type,
    hospital,
    county,
    total_users
  },
  statistics,
  filters
}) {
  const formatTitleRange = (from, to) => (`${moment(from).format('l')} - ${moment(to).format('l')}`)
  return (
    <div>
      <Item
        key={titles['registered']}
        title={titles['registered']}
        value={(filters['register_from'] && filters['register_to']) ? registered_users : total_users}
        label={(filters['register_from'] && filters['register_to']) ? formatTitleRange(filters['register_from'], filters['register_to']) : 'total'}
      />
      <Item
        key={titles['logged']}
        title={titles['logged']}
        value={logged_in_users}
        label={formatTitleRange(filters['logged_from'], filters['logged_to'])}
        appear={filters['logged_from'] && filters['logged_to']}
      />
      {
        ['user_type', 'county', 'hospital'].map(e => (
          <Item
            key={titles[e]}
            title={titles[e]}
            label={filters[e]}
            value={statistics[`${e}_users`]}
            appear={filters[e]}
          />
        ))
      }
    </div>
  );
}

Carts.defaultProps = {};

Carts.propTypes = {};

export default Carts;



/** WEBPACK FOOTER **
 ** ./src/components/Admin/Statistics/Users/Carts/index.jsx
 **/